/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const shield_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 4.888v7.095c0 5.123 3.375 8.931 8.006 10.728.994.385.994.385 1.988 0C17.625 20.914 21 17.106 21 11.983V4.888a1.412 1.412 0 0 0-.801-1.269C15.692 3.097 12 1 12 1S8.308 3.097 3.801 3.62a1.411 1.411 0 0 0-.8 1.268Z"
    />
  </svg>
)
export default shield_medium
